import { render, staticRenderFns } from "./DocumentsFiltersTypeFormField.vue?vue&type=template&id=9e2aca4a&lang=pug&"
import script from "./DocumentsFiltersTypeFormField.vue?vue&type=script&lang=ts&"
export * from "./DocumentsFiltersTypeFormField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports